import React from "react";
import styled from "styled-components";
import { Table as BsTable } from "react-bootstrap";
import { ItemListadoMascotas } from "../../../services/mascotasServicios";
import { useNavigate } from "react-router-dom";
import { RUTA_MASCOTAS } from "../../../services/rutas";

interface TableSectionProps {
  mascotas: ItemListadoMascotas[];
}

interface TableItemProps {
  mascota: ItemListadoMascotas;
}

function TableItem({ mascota }: TableItemProps) {
  let navigate = useNavigate();

  return (
    <StyledRow
      onClick={() => navigate(`${RUTA_MASCOTAS}/${mascota.id}`, { replace: false })}
    >
      <StyledCell>{mascota.nombre}</StyledCell>
      <StyledCell>{mascota.nombresPropietario}</StyledCell>
      <StyledCell>{mascota.raza}</StyledCell>
      <StyledCell>{mascota.direccion}</StyledCell>
      <StyledCell>{mascota.celular}</StyledCell>
      <StyledCell>{mascota.garrapaticidaAlDia ? "Si" : "No"}</StyledCell>
      <StyledCell>{mascota.vacunaAlDia ? "Si" : "No"}</StyledCell>
    </StyledRow>
  );
}

function Table({ mascotas }: TableSectionProps) {
  return (
    <StyledTable responsive hover>
      <thead>
        <tr>
          <StyledColHeader>Nombre</StyledColHeader>
          <StyledColHeader>Propietario</StyledColHeader>
          <StyledColHeader>Raza</StyledColHeader>
          <StyledColHeader>Dirección</StyledColHeader>
          <StyledColHeader>Celular</StyledColHeader>
          <StyledColHeader>Garrapaticida al día</StyledColHeader>
          <StyledColHeader>Vacuna al día</StyledColHeader>
        </tr>
      </thead>
      <tbody>
        {mascotas.map((_, index) => (
          <TableItem key={_.id} mascota={_} />
        ))}
      </tbody>
    </StyledTable>
  );
}

const StyledTable = styled(BsTable)``;

const StyledCell = styled("td")``;

const StyledColHeader = styled("th")`
  color: ${(props) => props.theme.colors.main};
`;

const StyledRow = styled("tr")`
  cursor: pointer;
`;

export default Table;
